


















import { Component, Prop, Watch } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import { date, timeFromNow } from "@/shared/filters";
import Tooltip from "@/shared/components/tooltip.vue";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";

@Component({
  components: { Loading, Tooltip, DataTable },
  filters: { date, timeFromNow },
})
export default class HistoricoAtendimentos extends mixins(GlobalMixin) {
  @Prop() atendimento!: any;
  historicos: Promise<any[]> | null = null;
  chamadas: any[] | null = null;
  headers = [
    { value: "dataChamada", text: "Data" },
    { value: "observacao", text: "Observação" },
    { value: "status", text: "Status" },
    { value: "usuario.nome", text: "Usuário" },
  ];

  @Watch("atendimento")
  changeAtendimento() {
    this.fetchHistoricos();
  }

  mounted() {
    this.fetchHistoricos();
  }

  fetchHistoricos() {
    if (this.atendimento) {
      if (this.atendimento.chamadas.length >= 1) {
        this.historicos = this.atendimento.chamadas;
      }
    }
  }

  setStatusAtendimento(status: number) {
    switch (status) {
      case 1:
        return "Reagendar";
      case 2:
        return "Sem contato";
      case 9:
        return "Fechar atendimento";
    }
  }
}
